var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"layer",staticClass:"__parallax-el-layer"},[_c('div',{ref:"wrap",staticClass:"__parallax-el-wrap"},[_c('div',{ref:"box",staticClass:"__parallax-el-box"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }